export default __webpack_public_path__ + "static/media/vengeanceofthegods.11a1033f.png";